import { BaseSheet, BaseSheetField, PageItem, DirectionEnum, AnswerText, ParamBaseSheetField, CurrentModeEnum } from "../../modules/student/DigitalReport"
import * as Common from "../../commons/common"

export class BaseSheetItem {
  student_sheet_id: string
  base_sheet: BaseSheet
  pageItems: PageItem[] = []
  base64QuestionImages: string[] = []
  base64ExplanationImages: string [] = []
  base64CorrectImages: string[] = []
  answerPageIdx: number = 0
  questionPageIdx: number = 0
  explanationPageIdx: number = 0
  correctPageIdx: number = 0
  baseSheetFieldIdx: number = null
  status: number
  currentMode: number
  times: number
  is_preview_mode: boolean

  // get pageItem(): PageItem {
  //   return this.pageItems[this.answerPageIdx];
  // }

  get base64QuestionImage(): string {
    return this.base64QuestionImages[this.questionPageIdx];
  }

  get base64ExplanationImage(): string {
    return this.base64ExplanationImages[this.explanationPageIdx];
  }
  
  constructor(x: any, cutMargin: number){
    this.base_sheet = new BaseSheet(x.base_sheet);
    this.base64QuestionImages = x.base64_question_images;
    this.base64ExplanationImages = x.base64_explanation_images;
    this.base64CorrectImages = x.base64_correct_images;
    this.status = x.status;
    this.times = x.times;

    for(let i = 0; i < this.base_sheet.page_count; i++){
      const pageItem = new PageItem(i + 1, x.base64_answer_images[i], x.base_sheet_fields, this.base_sheet.width, this.base_sheet.height, []);
      this.pageItems.push(pageItem);
    }

    // 教材の場合は自己採点結果を設定
    if(this.base_sheet.sheet_type == Common.SheetTypeEnum.LessonTest){
      this.pageItems.forEach(pageItem => {
        pageItem.base_sheet_fields.forEach(base_sheet_field => {
          const self_scoring = x.self_scorings.find((self_scoring: any) => self_scoring.base_sheet_field_id == base_sheet_field.id);
          if(self_scoring){
            base_sheet_field.correct_state = self_scoring.correct_state;
          }
        });
      });
    }

    // 解答・自己採点・プレビューモード判定
    if(this.base_sheet.sheet_type == Common.SheetTypeEnum.LessonKyouzai){
      // 教材の場合は提出の概念がなく、常に解答モード
      this.currentMode = CurrentModeEnum.Answer;
    }else{
      // テストの場合のモード判定
      if(this.status == Common.StudentSheetStatusEnum.Answering){
        // 提出前は解答
        this.currentMode = CurrentModeEnum.Answer;
      }else if(this.status == Common.StudentSheetStatusEnum.SelfScoring){
        // 自己採点中
        this.currentMode = CurrentModeEnum.SelfScoring;
      }else{
        // 提出済みはプレビュー
        this.currentMode = CurrentModeEnum.Preview;
      }
    }
  }
}

export interface Lesson {
  id: number
  nendo: number
  subject_code: string
  name: string
}

export interface LessonClass {
  id: number
  lesson_code: string
  lesson_class_no: string
}

export const TabNoEnum = Object.freeze({KyouzaiAnswer: 1, KyouzaiExplanation: 2, TestAnswer: 3, TestCorrect: 4, Questionnaire: 5});

